module.exports = __webpack_public_path__ + "img/f-8-2.fbc277e6.png";